<div class="overlay-preview" [ngClass]="{'mobile-app-layout': isMobileApp}">
  <div class="top-section">
    <div class="media-name">
      <div class="file-name">{{currentFileName }}</div>
    </div>
    <div class="media-controls">
      <div class="icon-container">
        <img [src]="isMobileApp ? 'assets/imgs/download.svg' : 'assets/images/download.svg'"
          class="icon-btn download-icon" (click)="download()"/>
      </div>

      <!-- Navigation controls shown only if there are multiple files -->
      @if (files.length > 1) {
        <span class="divider"></span>
        <div class="icon-container">
                    <img [src]="currentIndex == 0 
                                    ? (isMobileApp ? 'assets/imgs/previous-icon-disabled.svg' : 'assets/images/previous-icon-disabled.svg') 
                                    : (isMobileApp ? 'assets/imgs/previous-icon.svg' : 'assets/images/previous-icon.svg')"
            class="icon-btn previous-icon" [ngClass]="{'disabled' : currentIndex == 0}"
            (click)="previousMedia($event)" />
        </div>
        <span class="prev-next">
          {{ currentIndex + 1 }}/{{ files.length }}
        </span>
        <div class="icon-container">
                    <img [src]="currentIndex == files.length - 1 
                                    ? (isMobileApp ? 'assets/imgs/next-icon-disabled.svg' : 'assets/images/next-icon-disabled.svg')
                                    : (isMobileApp ? 'assets/imgs/next-icon.svg' : 'assets/images/next-icon.svg')"
            class="icon-btn next-icon" [ngClass]="{'disabled' : currentIndex == files.length - 1}"
            (click)="nextMedia($event)" />
        </div>
      }

      <span class="divider"></span>

      <div class="icon-container">
        <img [src]="isMobileApp ? 'assets/imgs/close-icon.svg' : 'assets/images/close-icon.svg'" alt="" class="icon-btn close-icon" (click)="close()" />
      </div>
    </div>
  </div>
  <div class="main-section">
    <div class="media-view">
      @if (!isLoading) {
        @if (currentUrl && isImageFile) {
          <div class="preview">
            <img [src]="currentUrl" class="preview-image" [alt]="currentFileName">
          </div>
        }
        @if (currentUrl && isPdfFile) {
          <div class="preview">
            @if (trustedPdfUrl) {
              <iframe [src]="trustedPdfUrl" class="preview-frame pdf-preview-frame"
                title="PDF Preview" loading="lazy">
              </iframe>
            }
          </div>
        }
        @if (currentUrl && isVideoFile) {
          <div class="preview">
            <video [src]="currentUrl" class="media-player" controls controlsList="nodownload">
              Your browser does not support the video preview.
            </video>
          </div>
        }
        @if (currentUrl && isAudioFile) {
          <div class="preview audio-preview">
            <audio [src]="currentUrl" class="media-player audio-player" controls controlsList="nodownload">
              Your browser does not support the audio preview.
            </audio>
          </div>
        }
        @if (currentUrl && isTextPreviewFile) {
          <div class="preview text-preview-wrapper">
            @if (textPreviewLoading) {
              <div class="text-preview-message">Loading preview...</div>
            }
            @if (textPreviewError && !textPreviewLoading) {
              <div class="text-preview-message">{{
              textPreviewError }}</div>
            }
            @if (!textPreviewLoading && !textPreviewError) {
              <pre
              class="text-preview-content">{{ textPreviewContent }}</pre>
            }
          </div>
        }
        @if (currentUrl && canUseOfficeViewer) {
          <div class="preview">
            @if (trustedOfficeViewerUrl) {
              <iframe [src]="trustedOfficeViewerUrl" class="preview-frame"
                title="Office Document Preview" loading="lazy">
              </iframe>
            }
          </div>
        }
        @if (currentUrl && !isImageFile && !isPdfFile && !isVideoFile && !isAudioFile && !isTextPreviewFile && !canUseOfficeViewer) {
          <div class="preview file-preview-card">
            <div class="file-preview-shell">
              <img [src]="isMobileApp ? 'assets/imgs/generic-file-icon.svg' : 'assets/images/generic-file-icon.svg'"
                class="file-icon">
              <p class="no-file-preview">No preview available for this file type.</p>
            </div>
          </div>
        }
      }
      @if (isLoading) {
        <div class="loading-indicator" aria-live="polite" aria-busy="true">
          <img [src]="isMobileApp ? 'assets/imgs/loader.gif' : 'assets/images/loader.gif'" alt="Loading..."
            class="loading-gif">
        </div>
      }
    </div>
  </div>

  <!-- Hidden anchor for triggering image downloads -->
  <a id="comments-images-download-trigger" class="visibility-hidden"></a>
</div>